/**
 * @param {void} func - The function to be debounced.
 * @param {number} wait - the waiting ms
 * @param {boolean} [immediate] - if we want to run it immediately
 */
function debounce(func, wait, immediate) {
    let timeout;
    return function executedFunction() {
        const context = this;
        const args = arguments;

        const later = () => {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        const callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
    };
}

module.exports = {debounce};
